import React, { useState, useEffect } from "react";
import SaveChangesButton from "./SaveChangesButton";

const GstInlineSetting = ({ gstData, setGstData, handleGstSubmit }) => {
  const [gstPercent, setGstPercent] = useState("");

  useEffect(() => {
    if (gstData?.gstPercent) {
      setGstPercent(gstData.gstPercent);
    }
  }, [gstData]);

  const handleChange = (e) => {
    setGstPercent(e.target.value);
  };

  const handleSave = async () => {
    if (!gstPercent) {
      alert("Please enter GST percentage");
      return;
    }
    await handleGstSubmit({ ...gstData, gstPercent });
  };

  return (
    <div className="gst-setting-container">
      <label className="gst-setting-label">GST Percentage (%)</label>
      <div className="gst-setting-inline">
        <input
          type="number"
          className="gst-setting-input"
          value={gstPercent}
          onChange={handleChange}
          placeholder="Enter GST %"
        />
        <SaveChangesButton
          className="gst-setting-save-btn"
          onClick={handleSave}
          label="Save"
        />
      </div>
    </div>
  );
};

export default GstInlineSetting;
